import { client } from "@/config/client"

export function deleteDocument(documentId: string) {
  return client.del(`/v1/documents/${documentId}`)
}
